import { Lock } from 'semaphore-async-await';
export class CacheService {
    constructor() {
        this.cache = {};
        this.lock = new Lock();
    }
    add(key, value, ttl) {
        let expiration = undefined;
        if (ttl) {
            expiration = Date.now() + ttl;
        }
        this.cache[key] = {
            value: value,
            expiration: expiration,
        };
    }
    get(key) {
        const item = this.cache[key];
        if (!item || item.expiration < Date.now()) {
            if (item) {
                this.delete(key);
            }
            return undefined;
        }
        return item.value;
    }
    async getOrAdd(key, factory, ttl) {
        let value = this.get(key);
        if (value) {
            return value;
        }
        if (!await this.lock.acquire()) {
            throw new Error('Could not acquire the lock');
        }
        try {
            value = this.get(key);
            if (value) {
                return value;
            }
            value = await factory();
            if (value) {
                this.add(key, value, ttl);
            }
            return value;
        }
        finally {
            await this.lock.release();
        }
    }
    delete(key) {
        delete this.cache[key];
    }
}
